let currentPage = 1;

// Cargar más "Actualidad"
let originalButtonText = jQuery('#load-more').text();

jQuery('#load-more').on('click', function () {
    currentPage++;

    let selectedYear = jQuery('#year-select').val();
    let selectedCategory = jQuery('#category-select').val();

    // Cambiar a preloader
    jQuery(this).html('<span class="spinner"></span>');


    // Cargar más contenido
    jQuery.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        dataType: 'json',
        data: {
            action: 'load_more',
            paged: currentPage,
            y: selectedYear,
            category: selectedCategory,
        },
        success: function (res) {
            if (currentPage >= res.max) {
                jQuery('#load-more').hide();
            }

            // Restaurar texto original del botón
            jQuery('#load-more').html(originalButtonText);

            jQuery('.publication-list').append(res.html);
        },
        error: function () {
            // En caso de error, restaurar texto original del botón
            jQuery('#load-more').html(originalButtonText);
        }
    });
});


// Cargar más "Ocasión"
let originalButtonTextOcasion = jQuery('#load-more-ocasion').text();

jQuery('#load-more-ocasion').on('click', function() {
    currentPage++;

    let parque = jQuery('#parque').val();
    let sector = jQuery('#sector').val();
    let categoria = jQuery('#categoria').val();
    let gama = jQuery('#gama').val();
    let marca = jQuery('#marca').val();

    jQuery(this).html('<span class="spinner"></span>');

    jQuery.ajax({
        type: 'POST',
        url: '/wp-admin/admin-ajax.php',
        dataType: 'json',
        data: {
            action: 'load_more_ocasion',
            paged: currentPage,
            parque: parque,
            sector: sector,
            categoria: categoria,
            gama: gama,
            marca: marca
        },
        success: function(res) {
            if (currentPage >= res.max) {
                jQuery('#load-more-ocasion').hide();
            }

            jQuery('#load-more-ocasion').html(originalButtonTextOcasion);

            jQuery('#ocasion-list').append(res.html);
        },
        error: function() {
            jQuery('#load-more-ocasion').html(originalButtonTextOcasion);
        }
    });
});
